import { Header } from '@/components/Header/Header';
import { BottomBar } from '@/components/BottomBar/BottomBar';

/**
 * Block 12 PR-D-A Phase D5 Step 8 — loading skeleton для КП.
 *
 * Показывается пока `state.hydrationStatus === 'pending'` — cascade
 * Zustand → IDB → anketa seed → blank (Step 9). Без skeleton'а пользователь
 * видел бы flash пустой формы перед hydration (если приходит из калькулятора
 * с `?projectId=`).
 *
 * Layout матчит финальный QuotePageView (Header + 7 placeholder blocks +
 * BottomBar) чтобы избежать layout shift на переходе skeleton → view.
 * Skeleton blocks — `animate-pulse` Tailwind utility.
 */
export function QuoteHydrationSkeleton() {
  return (
    <main
      className="min-h-screen flex flex-col bg-canvas"
      data-testid="quote-hydration-skeleton"
      aria-busy="true"
      aria-live="polite"
      aria-label="Загрузка коммерческого предложения"
    >
      <Header title="Коммерческое предложение" />
      <div className="flex-1 overflow-y-auto pb-6 pt-3 flex flex-col gap-4">
        {Array.from({ length: 6 }).map((_, i) => (
          <div
            key={i}
            className="mx-3 rounded-2xl bg-card/40 border border-accent/20 animate-pulse"
            style={{ height: i === 1 ? '320px' : '120px' }}
            aria-hidden="true"
          />
        ))}
      </div>
      <BottomBar variant="default" />
    </main>
  );
}
